// extracted by mini-css-extract-plugin
export var emphasizeQuantity = "_fc-3";
export var flatBottomCorners = "_fc-5";
export var productImage = "_fc-0";
export var quantityContainer = "_fc-2";
export var quantityHeader = "_fc-6";
export var tooltip = "_fc-1";
export var wrapAndEllipsesOverflow = "_fc-4";